import { Icon } from "@iconify/react";
import styles from "./Buttons.module.css";

export function SubmitButton({
  icon,
  iconPosition,
  form,
  isUpload,
  end,
  start,
  center,
  children,
  className,
  large = false,
  onClick,
  disabled,
}) {
  return (
    <button
      type="submit"
      className={`${isUpload ? styles.upload : className ? styles[className] : styles.submit} ${end && styles.end} ${
        start && styles.start
      } ${center && styles.center} ${large && styles.large}`}
      form={form}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && iconPosition === "start" && <Icon icon={icon} />}
      {children}
      {icon && iconPosition === "end" && <Icon icon={icon} />}
    </button>
  );
}

export function Button({
  icon,
  iconPosition,
  end,
  start,
  className,
  children,
  onClick,
  disabled,
  small = false,
  center,
}) {
  return (
    <button
      type="button"
      className={`${styles[className]} ${end && styles.end} ${start && styles.start} ${center && styles.center}`}
      onClick={onClick}
      disabled={disabled}
    >
      {icon && iconPosition === "start" && <Icon icon={icon} className={styles.icon} inline />}
      {small ? <span className="small">{children}</span> : children}
      {icon && iconPosition === "end" && <Icon icon={icon} className={styles.icon} inline />}
    </button>
  );
}

export function ToggleButton({ open, onClick }) {
  return (
    <button type="button" className={`${styles.toggle} ${open && styles.open}`} onClick={onClick}>
      <Icon icon="ri:arrow-drop-down-line" inline />
    </button>
  );
}

export function EditButton({ icon, iconPosition, end, start, children, onClick, disabled, className, small = false }) {
  return (
    <Button
      icon={icon ?? "carbon:edit"}
      iconPosition={iconPosition ?? "end"}
      end={end}
      start={start}
      className={className ?? "ghost_no_underline"}
      disabled={disabled}
      onClick={onClick}
    >
      {children ?? small ? <span className="small">Edit</span> : "Edit"}
    </Button>
  );
}
